export default "__VITE_ASSET__08db54ee__"